
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 6.75a9.07 9.07 0 012.297.281c.719.157 1.36.36 1.922.61.562.25 1 .625 1.312 1.125.313.5.469 1.03.469 1.593V12H6v-1.594c0-.594.156-1.14.469-1.64.312-.5.75-.875 1.312-1.125a9.926 9.926 0 011.922-.61A9.07 9.07 0 0112 6.75zm-8.016.234c.563 0 1.032-.187 1.407-.562.406-.406.609-.875.609-1.406 0-.563-.203-1.032-.61-1.407A1.834 1.834 0 003.985 3c-.53 0-1 .203-1.406.61-.375.374-.562.843-.562 1.406 0 .53.187 1 .562 1.406a2.01 2.01 0 001.406.562zM5.11 8.11a2.634 2.634 0 00-.515-.046 3.712 3.712 0 00-.61-.047c-.5 0-.984.046-1.453.14a7.113 7.113 0 00-1.312.422 1.897 1.897 0 00-.89.75A2.055 2.055 0 000 10.453V12h4.5v-1.594c0-.812.203-1.578.61-2.297zm14.907-1.125c.53 0 .984-.187 1.359-.562.406-.406.61-.875.61-1.406 0-.563-.204-1.032-.61-1.407C21 3.203 20.547 3 20.015 3c-.562 0-1.046.203-1.453.61-.375.374-.562.843-.562 1.406 0 .53.188 1 .563 1.406.406.375.89.562 1.453.562zM24 10.454c0-.407-.11-.782-.328-1.126a1.897 1.897 0 00-.89-.75 6.855 6.855 0 00-1.36-.422 6.705 6.705 0 00-1.406-.14c-.22 0-.422.015-.61.046-.187 0-.36.016-.515.047.406.72.609 1.485.609 2.297V12H24v-1.547zM12 0c.563 0 1.063.14 1.5.422.469.25.828.61 1.078 1.078.281.438.422.938.422 1.5a2.95 2.95 0 01-.422 1.547A2.97 2.97 0 0113.5 5.625c-.438.25-.938.375-1.5.375a3.235 3.235 0 01-1.547-.375 3.548 3.548 0 01-1.078-1.078A3.235 3.235 0 019 3c0-.563.125-1.063.375-1.5A2.97 2.97 0 0110.453.422 2.95 2.95 0 0112 0z"}})])
          )
        }
      }
    